import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Dictionary.css";
import Search from "../components/Search.js";
import Toast from "../services/Toast.js";
// Import images for the cards
import brand from "../assets/Brand.svg";
import molecule from "../assets/Molecule.svg";
import favourite from "../assets/Favourite.svg";
import dropDown from "../assets/dropDown.svg";

export default function Dictionary() {
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [favouriteItems, setFavouriteItems] = useState([]);
  const userId = sessionStorage.getItem("userId");
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const apiUrl = `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/favourites/${userId}`;
    // const apiUrl = `https://10.40.8.36:4004/medicaldictionary/v1/eyecare/favourites/${userId}`;

    // Fetching data
    fetch(apiUrl, {
      method: "GET",
      headers: {
        authorization: `bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // setData(data);  // Save the response data to state
        // setLoading(false);
        setFavouriteItems(data.data);
      })
      .catch((error) => {
        // setError(error.message);  // Handle any errors
        // setLoading(false);
        console.log(error);
      });
  }, []);

  const handleSearch = useCallback(async (query) => {
    console.log("Empty query");
    if (query.length === 0) {
      setSearchResults([]);
      setIsSearching(false);

      return;
    }
    // let querry = {
    //     "text": query,
    // };

    setIsSearching(true);
    try {
      // const response = await fetch("https://alembicdigilabs.in/medicaldictionary/v1/eyecare/keyword-search", {
      const response = await fetch(
        `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/search?query=${query}&userId=${userId}`,
        {
          // method: "POST",
          method: "GET",
          headers: {
            authorization: `bearer ${sessionStorage.getItem("token")}`,
          },
          // body: JSON.stringify(querry),
        }
      ); // Fetch from public folder
      const data = await response.json();

      // Filter results based on query
      // const filteredResults = data.results.filter(item =>
      //     item.name.toLowerCase().includes(query.toLowerCase())
      // );
      console.log(data.results);

      setSearchResults(data.results);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  }, []);

  return (
    <>
      <div className="dictionary-container">
        {/* Header */}
        <header className="text-left py-3">
          <p className="dictionaryHeader">Dictionary</p>
        </header>

        {/* Search Bar */}
        <Search onSearch={handleSearch} />

        {isSearching ? (
          <div className="mt-3">
            {searchResults?.brands?.length > 0 ||
            searchResults?.molecules?.length > 0 ? (
              <ul className="list-group">
                {searchResults.brands?.map((item, index) => (
                  <li key={`brand-${index}`} className="list-group-item">
                    <Link
                      to={`/brandDetails/${item.id}`}
                      className="text-decoration-none text-secondary"
                      state={{
                        from: "/dictionary",
                        brandDetails: item,
                        isFavorite: item.favourite,
                      }}
                    >
                      {item.Brand}
                    </Link>
                  </li>
                ))}

                {searchResults.molecules?.map((item, index) => (
                  <li key={`molecule-${index}`} className="list-group-item">
                    <Link
                      to={`/moleculeDetails/${item.id}`}
                      className="text-decoration-none text-secondary"
                      state={{
                        from: "/dictionary",
                        moleculeDetails: item,
                        isFavorite: item.favourite,
                      }}
                    >
                      {item.Molecule_Name}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted">No results found</p>
            )}
          </div>
        ) : (
          <>
            {/* Cards Section */}
            <div className="card-container">
              <div
                className="shadow-sm cards"
              >
                <Link to="/brand" className="text-decoration-none">
                  <img src={brand} alt="Brand" className="card-image" />
                  <div className="card-label">Brand</div>
                </Link>
              </div>

              <div className="shadow-sm cards">
                <Link to="/molecule" className="text-decoration-none">
                  <img src={molecule} alt="Molecule" className="card-image" />
                  <div className="card-label">Molecule</div>
                </Link>
              </div>
            </div>

            {/* Your Favourite Section */}
            <div className="favourite-section">
              <div className="favourite-header">
                <img src={favourite} alt="Card 2" />
                <p>Your Favourite</p>
              </div>
              <ul className="favourite-list">
                {favouriteItems.map((item, index) => (
                  <li key={index} className="favourite-item">
                    <Link
                      to={
                        item.Type === "Brand"
                          ? `/brandDetails/${item.id}`
                          : `/moleculeDetails/${item.id}`
                      }
                      className="text-decoration-none text-secondary"
                      state={{
                        from: "/dictionary",
                        brandDetails: item,
                        moleculeDetails: item,
                        isFavorite: true,
                      }}
                    >
                      {item.Type === "Brand" ? item.Name : item.Molecule_Name}
                    </Link>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="type-container">
                        <span
                          className={`favourite-type ${
                            item.Type === "Brand" ? "orange" : "blue"
                          }`}
                        >
                          {item.Type}
                        </span>
                      </div>
                      <img
                        src={dropDown}
                        alt="Dropdown"
                        className="dropdown-icon"
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>

      {/* Nested Route Content (Brand or Molecule) */}
      {/* <Outlet /> */}

      {showToast && (
        <Toast
          message="Brands Coming Soon!"
          onClose={() => setShowToast(false)}
        />
      )}
    </>
  );
}
